var app = angular.module('leonardo');

var DocumentListActions = function (
  $scope,
  $state,
  $http,
  $window,
  $rootScope,
  $filter,
  ConfigThemeService,
  ngDialog,
  FolderService,
  AuthDataService,
  SectorRestService,
  FilterService,
  NotificationService,
  AccountUserService,
  PermissionService,
  AuthService,
  moveMultipleService
) {
  $scope.mode = $state.current.mode ? $state.current.mode : 'normal';

  function getAccount(){
    if($scope.mode === 'account'){
      return null;
    }
    return AuthDataService.authData.account ? AuthDataService.authData.account.id : null;
  }

  $scope.account = getAccount();

  $scope.folder = null;

  $scope.permissionService = PermissionService;
  $scope.AuthService = AuthService

  $scope.$on('folder:loaded', function ($event, folder) {
    $scope.folder = folder;
  });

  $scope.getSector = function () {
    if (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) {
      if (FilterService.hasFilter('sector')) {
        return FilterService.getFilter('sector');
      }
      return (SectorRestService.getCollection().length > 0 ? SectorRestService.getCollection()[0].id : null);
    }
    return null;
  };

  $scope.hideLinksRoot = function () {
    if (['property', 'portfolio'].includes($scope.mode)) {
      return AuthDataService.authData.accountsManager ? AuthDataService.authData.accountsManager.length > 1 : false;
    } else {
      return AuthDataService.authData.accountsManager ? !$scope.folder && AuthDataService.authData.accountsManager.length > 1 : false;
    }
  };

  $scope.showCreate = function () {
    var show = false;
    var role_id = null;
    if ($scope.folder) {
      var account_user = AccountUserService.getAccountUser($scope.folder.account);
      if (account_user) {
        role_id = account_user.role ? account_user.role.id : account_user.role;
      }
      if (PermissionService.isOwner(account_user)) {
        show = true;
      } else if ($scope.folder.property) {
        let currentAccountProperty = $filter('filter')(FilterService.properties, {
          account: $scope.folder.account,
        });
        angular.forEach(currentAccountProperty, function (property) {
          if (property.id == $scope.folder.property) {
            if ($scope.folder.editable_by_roles && $scope.folder.editable_by_roles.length > 0) {
              show = $scope.folder.editable_by_roles.includes(role_id);
            } else {
              show = true;
            }
          }
        });
      } else if ($scope.folder.portfolio) {
        let currentAccountPortfolio = $filter('filter')(FilterService.portfolios, {
          account: $scope.folder.account,
        });
        angular.forEach(currentAccountPortfolio, function (portfolio) {
          if (portfolio.id == $scope.folder.portfolio) {
            if ($scope.folder.editable_by_roles && $scope.folder.editable_by_roles.length > 0) {
              show = $scope.folder.editable_by_roles.includes(role_id);
            } else {
              show = true;
            }
          }
        });
      } else {
        if ($scope.folder.editable_by_roles && ($scope.folder.editable_by_roles.length > 0)) {
          show = $scope.folder.editable_by_roles.includes(role_id);
        } else {
          show = true;
        }
      }
    } else if (['property', 'portfolio'].includes($scope.mode) || AccountUserService.currentAccountUsers.length === 1) {
      show = PermissionService.isOwner();
    }
    return show;
  };

  $scope.showFolderAddDialog = function () {
    ngDialog.open({
      template: 'views/templates/dialog/folder/add.html',
      controller: 'FolderAddDialog',
      data: {
        entity: FolderService.bulkObject($scope.account, $scope.getSector()),
        action: 'create'
      }
    });
  };

  $scope.showFileAddDialog = function () {
    ngDialog.open({
      template: 'views/templates/dialog/folder-file/upload.html',
      controller: 'FolderFileAdd',
      resolve: {
        folder: [
          '$q',
          function ($q) {
            if ($state.params.pk) {
              return FolderService.get($state.params.pk);
            }
            let defer = $q.defer();
            defer.resolve(null);
            return defer.promise;
          }
        ]
      },
      data: {
        entity: null,
        action: 'create'
      }
    });
  };

  $scope.downloadFolder = function () {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/folder/warning.html',
        controller: 'DownloadWarningDialog',
        data: {
          folder: $scope.folder
        }
      })
      .then(function (folder) {
        if (folder) {
          folder.download().then(function () {
            NotificationService.notify('success', 'An email will be sent to you in a few moments.');
          });
        } else {
          let url = ConfigThemeService.generateURL('/api/2.0/document-folders/download/');
          $http.get(url).then(function () {
            NotificationService.notify('success', 'An email will be sent to you in a few moments.');
          });
        }
      }, function () {
        return;
      });
  };

  $scope.onMoveMultipleFolder = function (){
     FolderService.showNext = !FolderService.showNext;
     FolderService.selectedSourceFolders = [];
     FolderService.selectedSourceFiles = [];
  }

  $scope.moveSelectedFolder = function () {
    if (FolderService.selectedSourceFolders.length > 0 || FolderService.selectedSourceFiles.length > 0) {
      var source_folder_ids = FolderService.selectedSourceFolders.map((folder)=>{return folder.id})
      var source_file_ids = FolderService.selectedSourceFiles.map((file)=>{return file.id})
      ngDialog
        .openConfirm({
          template: 'views/templates/dialog/folder/selector.html',
          controller: 'FolderSelectorDialog',
          data: {
            excludeFolder: source_folder_ids,
            sector: $scope.getSector(),
            rootDisabled: true,
            fromDL: true
          }
        })
        .then(function (data) {
          let move_multiples_data = { folder_ids: source_folder_ids, file_ids: source_file_ids, to_folder: data.destiny.id }
          moveMultipleService.post(move_multiples_data).then(function (res) {
            NotificationService.notify('success', res.detail);
            FolderService.showNext = false;
            FolderService.selectedSourceFolders = [];
            FolderService.selectedSourceFiles = [];
          })
            .catch(function () {
              NotificationService.error("An unexpected error has occurred.");
              FolderService.showNext = false;
              FolderService.selectedSourceFolders = [];
              FolderService.selectedSourceFiles = [];

            })

        }, function () {
          return;
        });

    }
  }

  $scope.checkShowNext = function(){
    return FolderService.showNext;
  }

  $scope.getSelectedFolderLength = function(){
    return (FolderService.selectedSourceFolders.length + FolderService.selectedSourceFiles.length)
  }
  
};

app.controller('DocumentListActions', [
  '$scope',
  '$state',
  '$http',
  '$window',
  '$rootScope',
  '$filter',
  'ConfigThemeService',
  'ngDialog',
  'FolderService',
  'AuthDataService',
  'SectorRestService',
  'FilterService',
  'NotificationService',
  'AccountUserService',
  'PermissionService',
  'AuthService',
  'moveMultipleService',
  DocumentListActions
]);
